import { API_ENDPOINTS } from "@utils/api/endpoints";
import { useSearchStore } from '@stores/search';

export default async function (params, body) {
  const search = useSearchStore();

  if (search.catalogueLoaded) {
    return { status: ref('success') };
  }

  search.setCatalogueLoaded(false);

  const { data, error, status } = await useApiFetch(API_ENDPOINTS.CATALOGUE_POST, {
    method: 'POST',
    params,
    body
  });

  if (status.value === 'error') {
    sentryCaptureEvent({
      message: 'load-content-catalogue',
      level: 'error',
      extra: { error: error.value }
    });
  } else {
    search.setCatalogue(data.value);
  }

  search.setCatalogueLoaded(true);
  return { data, error, status };
}
